import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SuppressEmailContainer from './Profile/Settings/SuppressEmailContainer';

import { updateEmailConfiguration } from '../../shared/actions';
import { RuntimeContext } from '../../../common/RuntimeContext';

class Unsubscribe extends PureComponent {
    static propTypes = {
        profile: PropTypes.object,
        updateEmailConfiguration: PropTypes.func.isRequired,
        userCompany: PropTypes.object
    };

    static contextType = RuntimeContext

    _updateToggleValue = (field) => (value) => {
        const { updateEmailConfiguration, profile } = this.props;
        const updateObject = {
            id: profile._id,
            emailConfig: { [`emailConfigs.${field}`]: value, revision: profile.revision },
            pathsContext: this.context.pathsWeb
        };
        return updateEmailConfiguration(updateObject);
    };

    render() {
        const { profile = {}, userCompany } = this.props;
        return (
            <div className={'unsubscribe container'}>
                <SuppressEmailContainer
                    updateEmailConfiguration={this._updateToggleValue}
                    configurations={profile.emailConfigs || {}}
                    email={profile.email}
                    companyConfigurations={userCompany.emailConfigs}
                    enableSaveButton={true}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        auth: { loggedInUserId, loggedInUserCompanyId },
        profiles: { byId },
        companies
    } = state;
    const userCompany = companies.byId[loggedInUserCompanyId];
    return {
        profile: byId[loggedInUserId],
        userCompany
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateEmailConfiguration: (params) => dispatch(updateEmailConfiguration(params))
});

export const UnsubscribeComponent = Unsubscribe;

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
